import type { FC } from 'react'

const MeasureReportRelatedView: FC = () => {
  return <></>
}

export default MeasureReportRelatedView
